import { type Meta } from '../types/docs';
import { WORKSPACE_AGENT_ANALYTICS_CATEGORY_META_PARAM } from './workspaceAgentAnalytics';

export const WORKSPACE_AGENT_MUTATION_TOOL_NAMES = [
  'apply_rename',
  'apply_tags',
  'assign_custom_field_values',
  'bulk_variants',
] as const;

export type WorkspaceAgentMutationToolName = (typeof WORKSPACE_AGENT_MUTATION_TOOL_NAMES)[number];

const META: Meta = {
  description:
    'The workspace agent applied a mutating tool that changed workspace assets (live toolResult WSS delivery). tool_params is a nested object with tool-specific keys: bulk_variants (destination_type, saved_count, failed_count, requested_count, output_status); apply_rename (renamed_count, output_status); apply_tags (tags_added_count, tags_removed_count, asset_count from toolCall sourcePillIds, output_status); assign_custom_field_values (asset_count, custom_field_id).',
  name: 'agent_workspace_modified',
  params: [
    WORKSPACE_AGENT_ANALYTICS_CATEGORY_META_PARAM,
    {
      description: 'The mutating tool that ran',
      name: 'tool_name',
      required: true,
      type: 'enum',
      values: [...WORKSPACE_AGENT_MUTATION_TOOL_NAMES],
    },
    {
      description: 'Whether metadata.success was true for the toolResult',
      name: 'success',
      required: true,
      type: 'boolean',
    },
    {
      description:
        'Whether a useful workspace mutation occurred (e.g. bulk_variants savedCount > 0 even when success is false)',
      name: 'mutation_occurred',
      required: true,
      type: 'boolean',
    },
  ],
};

export default META;
